// extracted by mini-css-extract-plugin
export default {"container":"album_container__JGOj1","image":"album_image__JBcG9"};